import { Paper } from "helpers/api";

/**
 * Formats a paper's metadata for display in dropdowns and lists.
 * Combines year and author last name, adding "et al." for multi-author papers.
 *
 * @example
 * // Single author: "2023 · Smith"
 * // Multiple authors: "2023 · Smith et al."
 * // No author: "2023"
 */
export const formatPaperDescription = (
  paper: Paper,
  etAlLabel: string
): string => {
  let description = `${paper.year}`;

  const authorPart = paper.primary_author || paper.authors?.[0];

  if (authorPart) {
    const authorName = authorPart.split(" ").pop() ?? authorPart;
    const authorText =
      paper.authors && paper.authors.length > 1
        ? `${authorName} ${etAlLabel}`
        : authorName;

    description = `${description} · ${authorText}`;
  }

  return description;
};
